import initGuestEntryModal from "components/jiffy/guest-entry-modal/guest-entry-modal";

initGuestEntryModal();
